import type * as React from 'react';
import { type FC, useCallback } from 'react';

import useCheckoutTranslation from '../../../hooks/useCheckoutTranslations';
import InputField, { type InputState } from '../InputField';
import type { Validation } from '../InputField/types';
import { NameMask } from '../InputField/utils/NameMask';
import type { NameState } from './types';

type Props = {
  onChange: (value: NameState) => void;
  isLastName?: boolean;
  required?: boolean;
  value?: string;
};

const mask = new NameMask();

const NameInput: FC<React.PropsWithChildren<Props>> = ({
  onChange,
  required,
  value,
  isLastName = false,
}) => {
  const { t } = useCheckoutTranslation();

  const handleOnChange = ({ maskedValue, isValid }: InputState) => {
    onChange({
      name: maskedValue,
      isValid,
    });
  };

  const label = isLastName ? 'LAST_NAME' : 'NAME';

  // biome-ignore lint/correctness/useExhaustiveDependencies: legacy code - correctness/useExhaustiveDependencies
  const validation: Validation = useCallback(
    ({ maskedValue }) => {
      // biome-ignore lint/style/useBlockStatements: legacy code - style/useBlockStatements
      if (maskedValue.length === 0)
        return { isValid: false, errorMessage: t(`REQUIRED_${label}`) };
      // biome-ignore lint/style/useBlockStatements: legacy code - style/useBlockStatements
      if (maskedValue.length < 3)
        return { isValid: false, errorMessage: t(`INVALID_${label}`) };
      return { isValid: true, errorMessage: '' };
    },
    [t],
  );

  return (
    <div className="mb-24">
      <InputField
        onChange={handleOnChange}
        label={t(`${label}_LABEL`)}
        validation={validation}
        required={required}
        value={value}
        mask={mask}
      />
    </div>
  );
};

export default NameInput;
